export const SUPPORTS_ARRAY_PROTOTYPE_JOIN = "join" in Array.prototype;
